import { css } from "@emotion/react"

export const selectContainerStyle = css`
	position: relative;
	width: inherit;
`
export const selectStyle = css`
	appearance: none;
	border-radius: 0;
	padding-right: 1rem;
	width: 100%;
	padding: 0.5rem 1rem;
	border-radius: 0.5rem;
	border: 1px solid #374151;
`
export const iconContainerStyle = css`
	position: absolute;
	right: 0.75rem;
	top: 50%;
	transform: translateY(-50%);
	opacity: 0.5;
	pointer-events: none;
`
